export { default as Headline } from './Headline';
